import {
  Button,
  FormControlLabel,
  FormGroup,
  Switch,
  useMediaQuery,
} from "@mui/material";
import styled from "styled-components";
import DownloadIcon from "@mui/icons-material/Download";
import { useState } from "react";

const ContainerDiv = styled.div`
  display: flex;
  flex-direction: ${({ $mobile }) => ($mobile ? "column" : "row")};
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

const BtnOptionExport = ({ onClick, typeData, dadosRelatorio }) => {
  const [csvChecked, setCsvChecked] = useState(true);
  const [pdfChecked, setPdfChecked] = useState(false);
  const isMobile = useMediaQuery("(max-width: 770px)");

  const handleChangeSwitch = (e, tipo) => {
    const { checked } = e.target;

    switch (tipo) {
      case "CSV":
        setCsvChecked(checked);
        if (!pdfChecked && !checked) {
          setPdfChecked(true);
          typeData("PDF");
        }
        if (!pdfChecked && checked) typeData("csv");
        if (pdfChecked && !checked) typeData("PDF");
        if (pdfChecked && checked) typeData("AMBOS");
        break;
      case "PDF":
        setPdfChecked(checked);
        if (!csvChecked && !checked) {
          setCsvChecked(true);
          typeData("csv");
        }
        if (!csvChecked && checked) typeData("PDF");
        if (csvChecked && !checked) typeData("csv");
        if (csvChecked && checked) typeData("AMBOS");
        break;
      default:
        break;
    }
  };

  const divPrincipal = {
    display: "flex",
    flexDirection: isMobile ? "row" : "column",
    alignItems: "flex-start",
    gap: "0rem",
  };

  const sxControl = {
    transform: isMobile ? "scale(1)" : "scale(0.8)",
    "& .MuiSwitch-switchBase.Mui-checked": { color: "#18316E" },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#18316E",
    },
  };

  const sxFormControl = (margin) => {
    return {
      color: "#18316E",
      marginBottom: margin,
      span: {
        fontSize: isMobile ? "1rem" : "0.8rem",
        fontWeight: isMobile ? 600 : 900,
        fontFamily: "Inter",
      },
    };
  };

  return (
    <ContainerDiv $mobile={isMobile}>
      <div style={divPrincipal}>
        {dadosRelatorio.exportaPdf && (
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  sx={sxControl}
                  checked={pdfChecked}
                  onChange={(e) => handleChangeSwitch(e, "PDF")}
                />
              }
              label="PDF"
              sx={sxFormControl("-1rem")}
            />
          </FormGroup>
        )}
        {dadosRelatorio.exportaExcel && (
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  sx={sxControl}
                  checked={csvChecked}
                  onChange={(e) => handleChangeSwitch(e, "CSV")}
                />
              }
              label="CSV"
              sx={sxFormControl("0rem")}
            />
          </FormGroup>
        )}
      </div>

      <Button
        sx={!isMobile ? { width: "200px" } : { width: "100%" }}
        variant="outlined"
        color="primary"
        startIcon={<DownloadIcon />}
        style={{ color: "#18316E", borderColor: "#18316E" }}
        onClick={onClick}
      >
        EXPORTAR
      </Button>
    </ContainerDiv>
  );
};

export default BtnOptionExport;
